module.exports = __webpack_public_path__ + "img/challenger.041178f.png";